import React from 'react';

const limitOptions = [10, 20, 50, 100];

const Pagination = ({ 
  currentPage, 
  total, 
  limit, 
  onPageChange,
  onLimitChange,
  showTotal = true,
  showArrows = true,
  showLimitSelector = true,
  className = ''
}) => {
  const totalPages = Math.ceil(total / limit);
  const hasPrev = currentPage > 1;
  const hasNext = (currentPage * limit) < total;

  const startElement = (currentPage - 1) * limit + 1;
  const endElement = Math.min(currentPage * limit, total);

  const handlePrev = () => {
    if (hasPrev) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (hasNext) {
      onPageChange(currentPage + 1);
    }
  };

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    onLimitChange(newLimit);
    // Сбрасываем на первую страницу при изменении лимита
    onPageChange(1);
  };

  return (
    <div className={`pagination-wrapper ${className}`}>
      <nav aria-label="Пример навигации по страницам" className="pagination">
        {showArrows && (
          <li className={`page-item ${!hasPrev ? 'disabled' : ''}`}>
            <a className="page-link" href="#" onClick={(e) => {
              e.preventDefault();
              handlePrev();
            }}>
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
        )}

        {showTotal && (
          <li className="page-item disabled">
            <span className="page-link">
              Страница {currentPage} из {totalPages}
            </span>
          </li>
        )}

        {showArrows && (
          <li className={`page-item ${!hasNext ? 'disabled' : ''}`}>
            <a className="page-link" href="#" onClick={(e) => { e.preventDefault(); handleNext(); }}>
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        )}
      </nav>

      <div className="pagination-info">
        <span className="pagination-total-items">Показано {startElement}-{endElement} из {total}</span>

      </div>

      {showLimitSelector && (
        <div className="pagination-limit-selector">
          <span className="pagination-limit-label">Показать:</span>
          <select
            value={limit}
            onChange={handleLimitChange}
            className="form-select page-limit-select"
            aria-label="Количество элементов на странице"
          >
            {limitOptions.map(opt => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default Pagination;
